import script from "./NewsPageBodyPostBody.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageBodyPostBody.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageBodyPostBody.vue?vue&type=style&index=0&id=5dd38737&scoped=true&lang=scss"
import "./NewsPageBodyPostBody.vue?vue&type=style&index=1&id=5dd38737&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dd38737"]])

export default __exports__